<template>
  <div style="display: inline-block">
    <el-button type="danger"
               size="mini"
               @click="open">
      <slot></slot>
    </el-button>

    <el-dialog
      title="发布搜索结果确定"
      :visible.sync="visible"
      :before-close="close"
      width="30%">
      <span>共{{count}}个任务，请输入总金额：{{salary}}</span>
      <br><br>
      <el-input v-model="inputSalary"
                placeholder="请输入总金额"></el-input>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="close()"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   :loading="count <= 0"
                   @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>

export default {
  components: {},
  props: {
    search: Object,
  },
  data () {
    return {
      visible: false,
      count: null,
      salary: null,
      inputSalary: null,
    }
  },
  watch: {
    visible (val) {
      if (!val) {
        this.close()
      }
    }
  },
  computed: {},
  methods: {
    open () {
      this.visible = true
      request.common('getTaskPublishOnSearchInfo', this.search).then(({data}) => {
        if (data.count <= 0) {
          this.visible = false
          this.$message.error('搜索结果数量为0')
          return
        }
        this.count = data.count
        this.salary = _.round(data.salary, 2)
      })
    },
    close () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onSubmit () {
      if (parseFloat(this.inputSalary) !== parseFloat(this.salary)) {
        this.$message.error('总金额输入错误，请重新提交')
        return false
      }

      return request.alert('taskPublishOnSearch', this.search).then(({data}) => {
        let message = '发布搜索结果成功' + data.success.length + '个'
        let duration = 3000
        let type = 'success'
        if (data.error.length) {
          message += `, 错误${data.error.length}个，第一个错误原因：${data.error[0].msg}`
          duration = 0
          type = 'warning'
        }
        this.$message({
          message,
          duration,
          type,
          showClose: true
        })
        this.$store.commit('OPEN_LOADING')
        setTimeout(() => {
          this.close()
          this.$emit('refresh')
          this.$store.commit('CLOSE_LOADING')
        }, 2000)
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskPublishOnSearchButton.vue